import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';

import { BelfiusCurrencyInput } from '../../../custom/belfius-currency-input';
import BelfiusCurrencyText from '../../../custom/belfius-currency-text';
import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { ValueAndCauseRequest as ValueAndCauseType } from '../../../../business/models/dto/rim/value-and-cause.request.dto';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './rim.module.css';
import { updateValuesAndCause, setCurrentTabAsDirty } from '../../../../store/details/rim/actions';
import Checkbox from '@mui/material/Checkbox';
import { Role } from '../../../../store/shared/model';

interface PropsFromState {
  readonly rimHeaderId: number;
  readonly insuredAmountBuilding: number | '';
  readonly insuredAmountContent: number | '';
  readonly valueAndCause: ValueAndCauseType;
  readonly locked: boolean;
}

interface PropsFromDispatch {
  readonly updateValues: typeof updateValuesAndCause;
  readonly setCurrentTabAsDirty: typeof setCurrentTabAsDirty;
}

type AllProps = PropsFromState & ConnectedReduxProps & PropsFromDispatch;

class ValueAndCause extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  private get insuredAmounts() {
    if (this.props.valueAndCause.cloned) {
      return (
        <div className={styles.row}>
          <div className={`${styles.item} ${styles.border}`}>
            <span className={styles.text}>
              {this.localization.get('details.shared.insuredAmountBuilding')}
            </span>
          </div>
          <div className={`${styles.item} ${styles.border}`}>
            <BelfiusCurrencyInput className={styles.input}
              disabled={this.props.locked}
              value={this.props.valueAndCause.cloneInsuredAmountBuilding}
              placeholder={this.localization.get('details.rim.valueAndCause.value')}
              onChange={() => {
                this.props.setCurrentTabAsDirty();
              }}
              onValueChange={(values: { value: string }) => {
                this.props.updateValues({ ...this.props.valueAndCause, cloneInsuredAmountBuilding: values.value });
              }}
            />
          </div>
          <div className={`${styles.item} ${styles.border}`}>
            <span className={styles.text}>
              {this.localization.get('details.shared.insuredAmountContent')}
            </span>
          </div>
          <div className={`${styles.item} ${styles.border}`}>
            <BelfiusCurrencyInput className={styles.input}
              disabled={this.props.locked}
              value={this.props.valueAndCause.cloneInsuredAmountContent}
              placeholder={this.localization.get('details.rim.valueAndCause.value')}
              onChange={() => {
                this.props.setCurrentTabAsDirty();
              }}
              onValueChange={(values: { value: string }) => {
                this.props.updateValues({ ...this.props.valueAndCause, cloneInsuredAmountContent: values.value });
              }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.row}>
          <div className={`${styles.item} ${styles.border}`}>
            <span className={styles.text}>
              {this.localization.get('details.shared.insuredAmountBuilding')}:&nbsp;
             <BelfiusCurrencyText value={this.props.insuredAmountBuilding} prefix={'€ '} />
            </span>
          </div>
          <div className={`${styles.item} ${styles.border}`}>
            <span className={styles.text}>
              {this.localization.get('details.shared.insuredAmountContent')}:&nbsp;
             <BelfiusCurrencyText value={this.props.insuredAmountContent} prefix={'€ '} />
            </span>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        {!this.props.rimHeaderId ?
          <div className={styles.content}>
            <div className={styles.row}>
              <div className={`${styles.item} ${styles.border}`}>
                <div className={styles.checkbox}>
                  <Checkbox
                    checked={this.props.valueAndCause.cloned}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      if (!event.target.checked) {
                        this.props.updateValues({ ...this.props.valueAndCause, cloned: event.target.checked, cloneInsuredAmountBuilding: '', cloneInsuredAmountContent: '' });
                      } else {
                        this.props.updateValues({ ...this.props.valueAndCause, cloned: event.target.checked });
                      }
                      this.props.setCurrentTabAsDirty();
                    }}
                    value='true' />
                  {this.localization.get('details.rim.clone')}
                </div>
              </div>
            </div>
          </div> : ''}
        <div className={styles.content}>
          {this.insuredAmounts}
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.shared.valueBuildingBeforeAccident')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <BelfiusCurrencyInput className={styles.input}
                disabled={this.props.locked}
                value={this.props.valueAndCause.valueBuildingBeforeAccident === "-1" ? '' : this.props.valueAndCause.valueBuildingBeforeAccident}
                placeholder={this.localization.get('details.rim.valueAndCause.value')}
                onChange={() => {
                  // set value and cause is dirty - cause change value came from change event of input box
                  this.props.setCurrentTabAsDirty();
                }}
                onValueChange={(values: { value: string }) => {
                  this.props.updateValues({ ...this.props.valueAndCause, valueBuildingBeforeAccident: values.value });
                }}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.shared.valueContentBeforeAccident')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <BelfiusCurrencyInput className={styles.input}
                placeholder={this.localization.get('details.rim.valueAndCause.value')}
                disabled={this.props.locked}
                value={this.props.valueAndCause.valueContentBeforeAccident === "-1" ? '' : this.props.valueAndCause.valueContentBeforeAccident}
                onChange={() => {
                  this.props.setCurrentTabAsDirty();
                }}
                onValueChange={(values: { value: string }) => {
                  this.props.updateValues({ ...this.props.valueAndCause, valueContentBeforeAccident: values.value });
                }}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              {(!this.props.valueAndCause.damageCauseRemark || !(this.props.valueAndCause.damageCauseRemark.trim().length > 0)) &&
                <div className={styles.notValid} ></div>
              }
              <textarea className={styles.text}
                rows={3}
                maxLength={500}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.shared.damageCauseRemark')}
                value={this.props.valueAndCause.damageCauseRemark}
                onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                  this.props.setCurrentTabAsDirty();
                  this.props.updateValues({ ...this.props.valueAndCause, damageCauseRemark: event.target.value });
                }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsRim, detailsPolicy }, caseState: { selectedCase }, shared: { roles } }: ApplicationState): PropsFromState => ({
  rimHeaderId: detailsRim.rimHeaderId,
  insuredAmountBuilding: detailsPolicy.policy.insuredAmountBuilding,
  insuredAmountContent: detailsPolicy.policy.insuredAmountContent,
  valueAndCause: detailsRim.valueAndCause,
  locked: detailsRim.locked === '' ? false : detailsRim.locked || selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateValues: (valueAndCause: ValueAndCauseType) => dispatch(updateValuesAndCause(valueAndCause)),
  setCurrentTabAsDirty: () => dispatch(setCurrentTabAsDirty())
});

export default connect(mapStateToProps, mapDispatchToProps)(ValueAndCause);
